import { generateVuexCrud } from '@/utilities/crud/vuex';

export default generateVuexCrud('filter');
